import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import FaPlay from 'react-icons/lib/fa/play';
import FaStop from 'react-icons/lib/fa/stop';
import MdClose from 'react-icons/lib/md/close';
import MdFileUpload from 'react-icons/lib/md/file-upload';
import SvgIconButton from '../../../components/SvgIconButton';
import FileAttach from '../../../components/FileAttach';
import infoIcon from '../../../assets/images/info';

const infoIconStyle = {
    width: '10px',
    height: '10px',
    minWidth: '10px',
    minHeight: '10px',
    borderRadius: 0
};

@inject('audioStore')
@observer
class UploadTrackFileSelect extends Component {
    render() {
        const {audioStore, fileName, previewError, onChange, onClear, onError, isValidated} = this.props;
        const {trackUrl, isPlayed, togglePlay, isMidi} = audioStore;
        return (
            <div className={trackUrl ? 'file-input-wrapper file-attached' : 'file-input-wrapper'}>
                <div className="file-input-label">
                    <FormattedMessage id="upload.form.attachments"/>
                </div>
                <div className={this.previewError ? 'file-input-button-wrap error' : 'file-input-button-wrap'}>
                    {trackUrl && !previewError && <div className="toggle-audio-btn" onClick={togglePlay}>
                        {isPlayed ? <FaStop /> : <FaPlay />}
                    </div>}
                    {fileName &&
                        <SvgIconButton className="delete-file-btn" containerClass="delete-file-btn-wrap" onClick={onClear}>
                            <MdClose/>
                        </SvgIconButton>
                    }
                    <FileAttach onChange={onChange} fileExtension='audio/*, video/mp4, .wma' onError={onError}>
                        <Fragment>
                            {(!trackUrl || previewError) && <div className="file-input-icon"><MdFileUpload /></div>}
                            <button className="file-input-button" type="button">
                                {fileName || <FormattedMessage id="upload.form.uploadPlaceholder"/>}
                            </button>
                        </Fragment>
                    </FileAttach>
                </div>
                {previewError &&
                    <div className="file-input-error">
                        <SvgIconButton
                            viewBox="0 0 12 12" icon={infoIcon} buttonStyle={infoIconStyle} hoverColor="none" rippleColor="none"
                            iconStyle={infoIconStyle} containerClass="file-input-error-icon"/>
                        <FormattedMessage id="upload.form.error.fileNotSup"/>
                    </div>
                }
                {(isValidated && !trackUrl && !isMidi) &&
                    <div className="file-input-error">
                        <SvgIconButton
                            viewBox="0 0 12 12" icon={infoIcon} buttonStyle={infoIconStyle} hoverColor="none" rippleColor="none"
                            iconStyle={infoIconStyle} containerClass="file-input-error-icon"/>
                        <FormattedMessage id="upload.form.error.fileEmpty"/>
                    </div>
                }
            </div>
        );
    }
}

export default UploadTrackFileSelect;
